export default __webpack_public_path__ + "static/media/Telnys Logo.01b38fb6.png";